export default function MoneyTriple({
  baseline,
  finalByEmp,
  deltas,          // { dcp, dcm, dsp, dsm, dtotal } for this staff
  staffIndex,
  roleKey,         // "cp" | "cm" | "sp" | "sm" | "total"
  onFilterClick,   // () => void (optional)
}) {

  // Money with 0 decimals, try to remove -0 bug
  const money2 = (n) => {
    const v = Math.round(((Number(n) || 0) + Number.EPSILON) * 100) / 100;
    const clean = Math.abs(v) < 0.5 ? 0 : v;      // threshold to zero
    return "$" + clean.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 });
  };

  const EPS = 0.5;


  // Pull base / final / delta for one staff & role
  function getBaseFinalDelta(baseline, finalByEmp, deltas, staffIndex, roleKey) {
    const baseSnap  = baseline.get(staffIndex)   || { cp:0, cm:0, sp:0, sm:0, total:0 };
    const finalSnap = finalByEmp.get(staffIndex) || { cp:0, cm:0, sp:0, sm:0, total:0 };

    const base  = baseSnap[roleKey]  || 0;
    const final = finalSnap[roleKey] || 0;

    const delta =
      roleKey === "cp" ? (deltas.dcp   || 0) :
      roleKey === "cm" ? (deltas.dcm   || 0) :
      roleKey === "sp" ? (deltas.dsp   || 0) :
      roleKey === "sm" ? (deltas.dsm   || 0) :
                        (deltas.dtotal || 0);

    return { base, final, delta };
  }

  const { base, final, delta } = getBaseFinalDelta(baseline, finalByEmp, deltas, staffIndex, roleKey);
  const zeroish = Math.abs(delta) < EPS;

  return (
    <>
      <td className="money-cell old">{money2(base)}</td>

      <td className="money-cell delta">
        <span className={`delta-chip ${zeroish ? "zero" : (delta > 0 ? "up" : "down")}`}>
          {zeroish ? "—" : (delta > 0 ? "+" : "−") + money2(Math.abs(delta))}
          {onFilterClick && (
            <button
              type="button"
              className="delta-filter-btn"
              title="Show only staff involved in this change"
              aria-label="Filter main table to participants"
              onClick={(e) => { e.stopPropagation(); onFilterClick(roleKey); }}
            >
              {/* funnel icon */}
              <svg viewBox="0 0 24 24" aria-hidden="true">
                <path d="M3 4h18l-7 8v6l-4 2v-8L3 4z" fill="none" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" />
              </svg>
            </button>
          )}
        </span>
      </td>

      <td className="money-cell new"><strong>{money2(final)}</strong></td>
    </>
  );
}